/**
 * Created by Lijing on 2017/3/23.
 */
"use strict";
import Vue from "vue";
import ElementUI from "element-ui";
Vue.use(ElementUI);
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
import axios from 'axios'
import x2js from 'x2js'
import request from "./request.js"
import store from './store/state'

//定制的话机型号以如NRP1202/P,以/前面的为设备型号，方便统一管理
//NRPXXXX后面的G,/P,W等忽略：例：NRP1500G/P','NRP1610G/P' 应该为NPR1500，NPR1610

/***** redstone 海外版 开始************/
// let RedstoneList = ['EGW50','RGW4','RGW8','RGW48','RGW96','REX20', 'REX200', 'REX50', 'REX500', 'REX1000']
// function redstoneObj(RedstoneList, flag = true) {
//   let result = []
//   RedstoneList.forEach(item => {
//     result.push({ text: item, value: item })
//   })
//   if (flag) {
//     result.push({ text: 'null', value: 'null' })
//   }
//   return result;
// }
/***** redstone 海外版 结束************/

let deviceTypeList = {
  'OM': ['OM20', 'OM20G', 'OM200G',"OM200G-A","MEVG",'OM50', 'OM50G', 'OM500', "OM1000", 'OM80', 'OM80E','OM80E-A', 'OM8000','MA50-LS','EGW50'],
  'MX': ['MX8A', 'MX8G', 'MX80E','MX60', 'MX60E','MX100G', 'MX120G',"MX120G-A",'HX4E', 'HX4G','RGW4','RGW8','RGW48','RGW96'],
  'IPPhone': ['NRP1202', 'NRP1212', 'NRP2013', 'NRP2002', 'NRP3002', 'NRP3012', 'NRP1500', 'NRP1610'],
  'SBC':['SX3000'],
  'REX': ['REX20', 'REX200', 'REX50', 'REX500', 'REX1000', 'REX8000'],
  'Other': [],

}
function configAll(obj, delItem = []){
  let newAll = [...obj['OM'], ...obj['MX'], ...obj['IPPhone'], ...obj['SBC']]
  return newAll.filter((x) => !delItem.some((item) => x == item));
}

function loadAll(obj, delItem = []) {
  let newAll = [...obj['OM'], ...obj['MX'], ...obj['IPPhone'], ...obj['SBC'], ...obj['REX'], ...obj['Other']]
  return newAll.filter((x) => !delItem.some((item) => x == item));
}

function loadOM(obj, delItem = []) {
  let omList = [...obj['OM']]
  return omList.filter((x) => !delItem.some((item) => x == item));
}

function loadMX(obj, delItem = []) {
  let mxList = [...obj['MX']]
  return mxList.filter((x) => !delItem.some((item) => x == item));

}

function loadIPPhone(obj, delItem = []) {
  let ipphoneList = [...obj['IPPhone']]
  return ipphoneList.filter((x) => !delItem.some((item) => x == item));
}

function loadRex(obj, delItem = []) {
  let rexList = [...obj['REX']]
  return rexList.filter((x) => !delItem.some((item) => x == item));
}

function loadOMOther(obj, delItem = []){
  let om = loadOM(deviceTypeList, delItem)
  return [...om,'OM1000-A-TE', 'tietrunk', 'SX10000', 'OMX',"MX60E-A"]
}

function loadOmMxIPPhoneRex(obj, delItem = []) {
  let om = loadOM(deviceTypeList, delItem)
  let mx = loadMX(deviceTypeList, delItem)
  let Ipphone = loadIPPhone(deviceTypeList, delItem)
  let rex = loadRex(deviceTypeList, delItem)
  let all = [...om, ...mx, ...Ipphone, ...rex]
  return all

}

function deviceListFunc(delItem = [], flag = true) {
  let result = []
  let all = loadAll(deviceTypeList, delItem)
  all.forEach(item => {
    result.push({ text: item, value: item })
  })
  if (flag) {
    result.push({ text: 'null', value: 'null' })
  }
  return result;
}

function autoUpgradeFunc(delItem = []) {
  let om = loadOM(deviceTypeList, delItem)
  let mx = loadMX(deviceTypeList, delItem)
  let ipphone = loadIPPhone(deviceTypeList, delItem)
  let rex = loadRex(deviceTypeList, delItem)
  let all = [...om, ...mx, ...rex, ...ipphone]
  return all
}


function upgradeCountFunc(delItem = []) {
  let result = []
  let all = loadOmMxIPPhoneRex(deviceTypeList, delItem)
  all.forEach(item => {
    result.push({ label: item, value: item, type: item })
  })
  return result
}

function package1Func(delItem = []) {
  let result = []
  let all = loadOmMxIPPhoneRex(deviceTypeList, delItem)
  all.forEach(item => {
    result.push({ label: item, value: item })
  })
  return result
}

function package2Func(delItem = []) {
  let result = []
  let mx = loadMX(deviceTypeList, delItem)
  mx.forEach(item => {
    result.push({ label: item, value: item })
  })
  return result

}

function package3Func(delItem = []) {
  let result = []
  let om = loadOM(deviceTypeList, delItem)
  om.forEach(item => {
    result.push({ label: item, value: item })
  })
  return result
}

function deviceListTableFunc(delItem = [], flag = true) {
  let result = []
  let all = autoUpgradeFunc(delItem)
  all.forEach(item => {
    result.push({ text: item, value: item })
  })
  if (flag) {
    result.push({ text: 'null', value: 'null' })
  }

  return result
}

function flatten(arr) {   //多维数组变为一维数组
  return [].concat( ...arr.map(x => Array.isArray(x) ? flatten(x): x) )
}

export default {
  lang:'/ums/language',
  login: "/passports/login",
  logout: "/passports/logout",
  role: "/passports/role",
  user: "/passports/user",
  tokenverify:"/passports/tokenverify",
  deviceGroup: "/domain/group",
  devices: "/device",
  domain: "/ums/domain",
  cloudID: "/ums/cloudid",
  discoryCloud: "/ums/device/discovery",
  changePasswd: "/xml?method=gw.account.change",
  deviceStatus: "/ums/device/status",
  statusExport: "/ums/device/status?export=true",
  downloadStatus: "/ums/download/tmp/",
  firmware: "/ums/res/upgrade/firmware",
  downFirmware: "/ums/download/firmware/",
  uploadApps: "/ums/res/upgrade/apps",
  downApps: "/ums/download/apps/",
  notifications: "/ums/notification",
  task: "/ums/task",
  logs: "/ums/logs",
  parameter: "/ums/device/parameter",
  parameter_mx: "/ums/device/parameter/mx",
  parameter_om: "/ums/device/parameter/om",
  parameter_ipphone: "/ums/device/parameter/IPPHONE",
  phoneConfig: "/ums/device/phoneconfig",
  phoneDeployTask: "/ums/device/phonedeploytask",
  phoneDeployStatus: "/ums/device/phonedeploystatus",
  phonenumres: "/ums/device/phonenumres",
  upgrade: "/ums/device/upgrade",
  template: "/ums/device/template",
  fileTemplate: "/ums/device/file_template",
  version: "/ums/version",
  access: "/passports/user/access",
  baseUp: "/ums/res/upgrade/base",
  alarm: "/ums/device/event",
  alarmRule: "/ums/device/alarmrule",
  cloudP: "/ums/res",
  downCloudP: "ums/download/cloud_firmware/",
  checkName: "/passports/check_valid",
  config: "/ums/config",
  macs: "/device/macs",
  phoneSet: "/ums/device/notifyserver?phone=true",
  notifyserver: "/ums/device/notifyserver",
  monitor: "/ums/device/monitor",
  whiteList: "/ums/config/device_whitelist",
  license: "/ums/addon/devlicense",
  licenseOm8000: "/ums/addon/devlicense?v2=true",
  licenseUms: "/ums/addon/umslicense",
  licensethrough:"/ums/addon/licensenotify",
   licenseAS:"/ums/addon/nlkaslicense",
   licenseNewlync:"/ums/addon/newlynclicense",
   licenseEx:"/ums/addon/p2plicense",
   licenserms:"/ums/addon/rmslicense",
   licenseTLS:"/ums/addon/devtls",
  neehau: "/ums/app/neehua/report",
  neehauLog: "/ums/download/report_file_fs/",
  stat: "/ums/addon/stat/",
  deviceType: "/ums/device/products/",
  acsserver: "/ums/config/acsserver", //ACS服务器配置页面 //ACS服务器配置页面
  metaprofile:'/ums/device/metaprofile',
  autoprovision: "/ums/autoprovision/template", //模板管理界面
  deviceAutoprovision: "/ums/device/autoprovision", //设备设置模板
  autoproList:'/ums/device/autoprolist', //根据MAC列表获取配置列表
  sysmonitor:'/ums/config/sysmonitor', //系统告警推送
  metaproname:'/ums/device/metaproname?type=autoprovision',
  getChartinfo:'/ums/config/chartinfo?page=1&limit=100&offset=0',
  bigChartinfo:'/s1/chartinfo?page=1&limit=100&offset=0',
  operateChart:'/ums/config/chartinfo',
  bigAlarmStatics:'/s1/device/metric_history/statistics',
  statusMonitor:'/ums/device/status_monitoring?limit=200&offset=0', //设备状态监控列表
  delStatusMonitor:"/ums/device/status_monitoring",
  server:"/ums/push/server",
  deviceinfo:"/ums/push/deviceinfo",
  cdrs:'/ums/push/cdrs',
  // 定义设备类型
  // deviceList: deviceListFunc(), //设备列表deviceList、设备配置deviceConfig
  autoUpgrade: autoUpgradeFunc(['OM8000']), //升级-》自动升级 autoUpgrade
  manualUpgrade: autoUpgradeFunc(['OM8000']), //创建升级任务 manualUpgrade autoUpgradeFunc
  upgradeCount: upgradeCountFunc(['OM8000']), //升级统计
  configVoip: upgradeCountFunc(), //配置管理
  package1: package1Func(['OM8000']), //管理-》升级包 package
  package2: package2Func(), //管理-》升级包 package
  package3: package3Func(['OM8000']), //管理-》升级包 package
  package4: autoUpgradeFunc(['OM8000']), // 管理-》升级包-》基础版本要求 请输入基础版本信息
  package5: autoUpgradeFunc(['OM8000']), // 管理-》升级包 package
  package6: loadIPPhone(deviceTypeList), // 管理-》升级包 package
  alarmDevice: autoUpgradeFunc(), //监控告警
  deviceListTable: deviceListTableFunc(),
  licenseOm80001: loadOM(deviceTypeList), //制作证书
  licenseOm80003: loadOMOther(deviceTypeList), //制作证书
  licenseOm80002: loadRex(deviceTypeList),
  setConfigTask: autoUpgradeFunc(), //任务列表-》下发配置
  setFileTask: autoUpgradeFunc(),
  taskDeviceList: autoUpgradeFunc(),


  okMsg: msg => {
    Vue.prototype.$message({
      showClose: true,
      message: msg,
      type: "success"
    });
  },
  failMsg: msg => {
    Vue.prototype.$message({
      showClose: true,
      message: msg,
      type: "warning"
    });
  },
  formatNum: num => {
    if (num < 10) {
      return "0" + num;
    } else {
      return num;
    }
  },
  formatDate: (time, string = "-") => {
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    var date = time.getDate();
    var hour = time.getHours();
    var minute = time.getMinutes();
    var second = time.getSeconds();
    if (month < 10) {
      month = "0" + month;
    }
    if (date < 10) {
      date = "0" + date;
    }

    return year + string + month + string + date;
  },

  formatTime: (time, string = "-") => {
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    var date = time.getDate();
    var hour = time.getHours();
    var minute = time.getMinutes();
    var second = time.getSeconds();
    if (month < 10) { month = "0" + month; }
    if (date < 10) { date = "0" + date; }
    if (hour < 10) { hour = "0" + hour }
    if (minute < 10) { minute = "0" + minute }
    if (second < 10) { second = "0" + second }
    return year + string + month + string + date + ' ' + hour + ':' + minute + ':' + second
  },

  formatTime1: (time) => {
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    var date = time.getDate();
    var hour = time.getHours();
    var minute = time.getMinutes();
    var second = time.getSeconds();
    if (month < 10) { month = "0" + month; }
    if (date < 10) { date = "0" + date; }
    if (hour < 10) { hour = "0" + hour }
    if (minute < 10) { minute = "0" + minute }
    if (second < 10) { second = "0" + second }
    return year.toString() + month.toString() + date.toString() + hour.toString() + minute.toString() + second.toString()

  },

  timeDifference: (oldTime, value = 172800000) => { //判断时间是否在48小时之内
    return new Date() - new Date(oldTime) > value ? false : true
  },

  getDuration(oldTime) { // 得出时间差
    let umslang = localStorage.getItem('umslang') || 'zh-cn'
    let dayago = umslang == 'zh-cn' ? '天前' : "days ago"
    let hourago = umslang == 'zh-cn' ? '小时前' : "hours ago"
    let minutesago = umslang == 'zh-cn' ? '分钟前' : "minutes ago"
    let secondsago = umslang == 'zh-cn' ? '秒前' : "seconds ago"
    let just = umslang == 'zh-cn' ? '刚刚' : "just"

    var second = Math.floor((new Date() - new Date(oldTime)) / 1000)
    var days = Math.floor(second / 86400);
    var hours = Math.floor((second % 86400) / 3600);
    var minutes = Math.floor(((second % 86400) % 3600) / 60);
    var seconds = Math.floor(((second % 86400) % 3600) % 60);
    if (days != 0) return days + dayago  // '天前'
    if (hours != 0) return hours + hourago //'小时前'
    if (minutes != 0) return minutes + minutesago // '分钟前'
    if (seconds != 0) return seconds + secondsago //'秒前'
    if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) return just //"刚刚";
  },
  judgeObjHasKey(obj, key) { //判断对象里是否包含的key
    if (Object.prototype.toString.call(obj) === '[object Object]') {
      if (obj.hasOwnProperty(key)) {
        return true;
      }
    }
    return false;
  },

  /*
   获取x轴数据显示
   从现在时间，向前推算
   num:数值
   unitOfTime:时间单位 day, mon, hour
  */
  getBigScreenX(num, unitOfTime) {
    let result = new Object()
    let xKey = [] //存储x轴
    let sTime = '' //开始时间的时间戳
    let prevTime = '' //前一个时间的时间
    let time = ''
    let xTime = []
    let time2 = ''
    let prevTemp = '' //前一个时间的时间戳
    let umslang = localStorage.getItem('umslang') || 'zh-cn'

    if (unitOfTime != 'mon') {
      if (unitOfTime == 'hour') { //小时
        prevTemp = new Date(new Date().setHours(new Date().getHours()- num+1))
      } else if (unitOfTime == 'day') {
        prevTemp = new Date(new Date().setDate(new Date().getDate() - num))
      }
      result['etime'] = this.formatTime1(new Date());
      result['stime'] = this.formatTime1(prevTemp);
    } else {
      let myDate = new Date();
      let year = myDate.getFullYear(); //现在时间 年
      let month = myDate.getMonth() + 1; //现在时间 月
      let day = myDate.getDate(); //现在时间 天
      let hour = myDate.getHours(); // 小时
      let minute = myDate.getMinutes(); // 分钟
      let second = myDate.getSeconds(); //秒
      var nowYear = year;
      var nowMonth = month;
      let lowData='';//当前年月日往前推m个月后获取到的年月日
      let ylow=parseInt(parseInt(num)/12);//往前推的总月份换成对应的年数取整
      let mlow=parseInt(num)%12;//往前推的月数
      if(ylow>0){
        year-=ylow;//年要再减一
      }else{
        year=year;//年取当前年份
      }
      if((mlow>month) || (mlow==month)){//往前推的月份大于或等于当前月份，12减去往前推的月份加上现在的月份
        year=year-1;
        month=12-mlow+month;
      }else{//往前推的月份小于当前月份
        month-=mlow;
      }
      if (month < 10) {
          month = '0' + month;
      }
      if (day < 10) {
         day = '0' + day;
      }
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (minute < 10) {
        minute = '0' + minute;
      }
      if (second < 10) {
        second = '0' + second;
      }
      let ymd = year.toString() + month.toString() + day.toString();
      let hms = hour.toString() + minute.toString() + second.toString();
      result['etime'] = this.formatTime1(new Date());
      result['stime'] = ymd + hms;
    }
    for (let i = 0; i < num; i++) {
      if(unitOfTime == 'mon'){
        if (nowMonth < 10) {
            nowMonth = '0' + nowMonth;
        }
        time = nowYear + '-' + nowMonth
        time2 = nowYear + '-' + nowMonth
        nowMonth -= 1;
        if(nowMonth<=0){
          nowMonth = 12
          nowYear-=1;
        }
      }else{
         if (unitOfTime == 'hour') {
            prevTime = new Date(new Date() - (1000 * 3600 * i)); //取需要提前到小时的时间戳
         }else if (unitOfTime == 'day') {
            prevTime = new Date(new Date() - (1000 * 3600 * 24 * i)); //取需要提前到某天的时间戳
         }

          let timeMinY = prevTime.getFullYear(); //年
          let timeMinM = prevTime.getMonth() + 1 <= 9 ? '0' + (prevTime.getMonth() + 1) : prevTime.getMonth() + 1;
          let timeMinD = prevTime.getDate() <= 9 ? '0' + prevTime.getDate() : prevTime.getDate();
          let timeMinH = prevTime.getHours() <= 9 ? '0' + prevTime.getHours() : prevTime.getHours();
          let timeMinMin = prevTime.getMinutes() <= 9 ? '0' + prevTime.getMinutes() : prevTime.getMinutes();
          if (unitOfTime == 'hour') {
            let text = umslang == 'zh-cn' ? ' 时': ' H'
            time = timeMinH + text
            time2 = timeMinY + '-' + timeMinM + '-' + timeMinD + " " + timeMinH
          } else if (unitOfTime == 'day') {
            time = timeMinM + '-' + timeMinD
            time2 = timeMinY + '-' + timeMinM + '-' + timeMinD
          }
      }
      xKey.push(time)
      xTime.push(time2)
    }

    result['x'] = xKey.reverse()
    result['xTime'] = xTime.reverse()
    // console.log('time', result)
    return result;
  },

  /**
   * 设备型号处理
   */

  getSeries(om, mx, ipphone,sbc,dValue=false ) { //升级包系列
    let result = []
    let allArr = []
    if(!om && !mx && !ipphone && !sbc){
      if(dValue) {
        allArr = ['OM','MX', 'IPPHONE','SBC']
      }else{
        return false
      }
    }else{
      allArr = [...om, ...mx, ...ipphone, ...sbc]
    }
    allArr.forEach(item => {
        result.push({ label: item, value: item })
    })
    return result
  },

  // allDeviceListArr(obj, delItem = []){//获取所有设备，数组类型
  //   if(!obj){
  //     return false
  //   }
  //   let newAll = flatten(Object.values(obj));// [...obj['OM'], ...obj['MX'], ...obj['IPPhone']]
  //   return newAll.filter((x) => !delItem.some((item) => x == item));
  // },

  configIPPhone(obj, delItem = []){ //获取所有话机
     if(!obj){
       return false
     }
     return loadIPPhone(obj, delItem = [])
  },

  alldeviceArr(obj, flag = true) { //获取所有设备 数组
    if(!obj){
      return false
    }
    let result = []
    let deviceObj = store.getters.config.deviceAlias || JSON.parse(localStorage.getItem("umsConfig")).deviceAlias
    let filterArr = flatten(Object.values(obj));
    filterArr.forEach(item => {
        result.push({ text:deviceObj[item] || item, value: item })
    })
    if (flag) {
        result.push({text: 'null', value: 'null' })
    }
    return result;
  },

  // package1Config(obj, delItem = []) {
  //   if(!obj){
  //     return false
  //   }
  //   let result = []
  //  let filterArr = configAll(obj, delItem = []);
  //   filterArr.forEach(item => {
  //     result.push({ label: item, value: item })
  //   })
  //   return result
  // },

  configPackageOm(obj, delItem = []){
    let result = []
    if(!obj){
      return false
    }
    let om = loadOM(obj, delItem)
    om.forEach(item => {
      result.push({ label: item, value: item })
    })
    return result

  },

  configPackageMx(obj, delItem = []){
    let result = []
    if(!obj){
      return false
    }
    let mx = loadMX(obj, delItem)
    mx.forEach(item => {
      result.push({ label: item, value: item })
    })
    return result

  },

  ConfigupgradeCountFunc(obj, delItem = []) {
    let result = []
    if(!obj){
      return false
    }
    let deviceObj = store.getters.config.deviceAlias || JSON.parse(localStorage.getItem("umsConfig")).deviceAlias
    let all = configAll(obj, delItem = []);
    all.forEach(item => {
      let type = ''
      if(item.includes('OM') || item.includes('REX') || item.includes('EGW') || item.includes('MEVG') || item.includes('MA')){
        type = "OM"
      }
      if(item.includes('MX') || item.includes('RWG') || item.includes('HX')){
        type = "MX"
      }
      if(item.includes('NRP')){
        type = 'IPPHONE'
      }
      result.push({ label: deviceObj[item] || item, value: item, type: type })
    })
    return result
  },

  paramTab(obj) {
    let result = []
    if(!obj){
      return false
    }
      if(obj['OM'] && obj['OM'].length > 1){
         result[0] = obj['OM'].join('/')
      }
      if(obj['MX'] && obj['MX'].length > 1){
         result[1] = obj['MX'].join('/')
      }
      if(obj['IPPhone'] && obj['IPPhone'].length > 1){
         result[2] = obj['IPPhone'].join('/')
      }
    return result

  },


 sendGetAxios(url) { //封装get请求
   if(url.includes('pass=admin') && url.includes('proxy')){
     url = url.replace(/proxy/g, 'proxy/ums')
   }
   return new Promise((resolve, reject) => {
     axios.get(url).then((res) => {
       resolve(res.data);
     });
   });
 },

 sendPostAxios(url, data) { //封装post请求
   return new Promise((resolve, reject) => {
     axios.post(url, data).then((res) => {
       resolve(res.data);
     });
   });
 },

 sendDeleteAxios(url) { //封装get请求
   return new Promise((resolve, reject) => {
     axios.delete(url).then((res) => {
       resolve(res.data);
     });
   });
 },

 xmlToJson(data) {
   let result = {}
   try{
   if ($($.parseXML(data.toString())).find("rsp").attr("stat") !== "fail") {
     $($.parseXML(data.toString()))
       .find("item")
       .each(function () {
         let value = $(this).attr("value") || ''
         let key = 'id'+ $(this).attr("id")
         result[key] = value
       });
   }
   }catch(err){
   }
   return result;
 },

 jsonFromXml(data){
      try{
      let x2j = new x2js();
      let temp = x2j.xml2js(data)
      return temp.rsp.config.item
      }catch(err){
        return ;
      }

 },



 getBitFromNum: function (num, bit) {
       return (num >> bit) & 1
 },

 /**
  * 2进制转化为16进制
  */

     binToHex: function (str) {
       var hex_obj = {
        "0000":0,
        "0001":1,
        "0010":2,
        "0011":3,
        "0100":4,
        "0101":5,
        "0110":6,
        "0111":7,
        "1000":8,
        "1001":9,
        "1010":'A',
        "1011":'B',
        "1100":'C',
        "1101":'D',
        "1110":'E',
        "1111":'F'
       }
       return hex_obj[str]
     },





 /**
  * 16进制转化为二进制
  */
 hexToBin: function(str) {
   var hex_array = [
     { key: 0, val: "0000" },
     { key: 1, val: "0001" },
     { key: 2, val: "0010" },
     { key: 3, val: "0011" },
     { key: 4, val: "0100" },
     { key: 5, val: "0101" },
     { key: 6, val: "0110" },
     { key: 7, val: "0111" },
     { key: 8, val: "1000" },
     { key: 9, val: "1001" },
     { key: 'a', val: "1010" },
     { key: 'b', val: "1011" },
     { key: 'c', val: "1100" },
     { key: 'd', val: "1101" },
     { key: 'e', val: "1110" },
     { key: 'f', val: "1111" },
     { key: 'A', val: "1010" },
     { key: 'B', val: "1011" },
     { key: 'C', val: "1100" },
     { key: 'D', val: "1101" },
     { key: 'E', val: "1110" },
     { key: 'F', val: "1111" }];
    var value = "";
    for (var i = 0; i < str.length; i++) {
        for (var j = 0; j < hex_array.length; j++) {
            if (str.charAt(i) == hex_array[j].key) {
                value = value.concat(hex_array[j].val)
                break
            }
        }
    }
    return value
 },



  //数字得到规定的长度，小于规定长度，前面补0,得到的结果为string类型
  prefixIntrger: function(num,length){
    return ((Array(length).join("0")+num).slice(-length));
   },

  getDeviceUrl: function(param3='', deviceInfo={}, param1='proxy', param2='ums'){ //获取设备请求地址
     if(deviceInfo.device_mac){
       return `/${param1}/${param2}/${deviceInfo.device_mac}${param3}`
     }
     return `/${param1}/${param2}${param3}`
  },

  getUmsGetAxios: function(url, deviceInfo={}) {
    let urlNew = url.replace(/proxy/g, 'proxy/ums')
    return request.get(urlNew)
  },

  getUmsPostAxios: function(url, data, deviceInfo={}) {
    let urlNew = url.replace(/proxy/g, 'proxy/ums')
    if(data){
      return request.post(urlNew, data)
    }
    return  request.post(urlNew)

  }






};



// WEBPACK FOOTER //
// ./src/api.js